import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { usrRole } from "../../utils/dataUtil";
import { Table, Card } from "antd";
import { req_list_pim_overtime_log_agree_staff } from "../../api";

class OvertimeMonthDetialsModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    item: {},
    loading: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    data: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_item_list();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    const { OverTimeMonth, StaffCode } = this.props.data;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_overtime_log_agree_staff(
      userLevel,
      userCode,
      OverTimeMonth,
      StaffCode,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "姓名",
        width: "50px",
        align: "center",
        render: (item) => {
          const { StaffName } = item;
          return <span style={{ fontWeight: 900 }}>{StaffName}</span>;
        },
      },
      {
        title: "日期",
        width: "30px",
        align: "center",
        render: (item) => {
          const { OvertimeDate } = item;
          return <span style={{ fontWeight: 900 }}>{OvertimeDate}</span>;
        },
      },
      {
        title: "加班時數",
        width: "50px",
        align: "center",
        render: (item) => {
          const { HoursAndMinutes } = item;
          return (
            <span>
              {HoursAndMinutes}
            </span>
          );
        },
      },
    ];
  };
  render() {
    const { data, loading } = this.state;
    return (
      <Card>
        <Table
          bordered
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(OvertimeMonthDetialsModal);
